import { DomainRule } from '../../types';
import { TriggersConfigMap, TriggerType } from 'sections/onsite-campaigns/types';

export interface MessageOnClickSelectorRequiredRuleDto {
  triggers?: Partial<TriggersConfigMap>;
}

export const MessageOnClickSelectorRequiredRuleKey = 'onClickSelectorRequired';

export const MessageOnClickSelectorRequiredRule = (dto: MessageOnClickSelectorRequiredRuleDto): DomainRule => {
  const onClickTrigger = dto?.triggers?.[TriggerType.OnClick];
  if (onClickTrigger?.active && !onClickTrigger?.value?.selector) {
    return {
      result: 'fail',
      ruleKey: MessageOnClickSelectorRequiredRuleKey,
    };
  }

  return {
    result: 'pass',
    ruleKey: undefined,
  };
};
